"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apis = exports.PriceInfo = exports.ItemPriceSummary = exports.ItemPriceRepairer = exports.ItemPriceDiagnosticInfo = exports.ItemPriceDiagnostic = exports.ItemPriceAdjustment = void 0;
require("regenerator-runtime/runtime");
var _react = _interopRequireDefault(require("react"));
require("./styles/styles.css");
var _i18n = require("./utils/i18n");
var _PriceInfo2 = _interopRequireDefault(require("./components/PriceInfo"));
var _ItemPriceRepairer2 = _interopRequireDefault(require("./components/ItemPriceRepairer"));
var _ItemPriceDiagnostic2 = _interopRequireDefault(require("./components/ItemPriceDiagnostic"));
var _ItemPriceDiagnosticInfo2 = _interopRequireDefault(require("./components/ItemPriceDiagnostic/ItemPriceDiagnosticInfo"));
var _ItemPriceSummary2 = _interopRequireDefault(require("./components/ItemPriceSummary"));
var _ItemPriceAdjustment2 = _interopRequireDefault(require("./components/ItemPriceAdjustment"));
var _fulfillerIdentity = require("./apis/fulfillerIdentity");
var _billableEntity = require("./apis/billableEntity");
var _merchantConfig = require("./apis/merchantConfig");
var _accounts = require("./apis/accounts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var PriceInfo = function PriceInfo(props) {
  return /*#__PURE__*/_react["default"].createElement(_PriceInfo2["default"], _extends({
    i18n: (0, _i18n.getI18nInstance)()
  }, props));
};
exports.PriceInfo = PriceInfo;
var ItemPriceRepairer = function ItemPriceRepairer(props) {
  return /*#__PURE__*/_react["default"].createElement(_ItemPriceRepairer2["default"], _extends({
    i18n: (0, _i18n.getI18nInstance)()
  }, props));
};
exports.ItemPriceRepairer = ItemPriceRepairer;
var ItemPriceDiagnostic = function ItemPriceDiagnostic(props) {
  return /*#__PURE__*/_react["default"].createElement(_ItemPriceDiagnostic2["default"], _extends({
    i18n: (0, _i18n.getI18nInstance)()
  }, props));
};
exports.ItemPriceDiagnostic = ItemPriceDiagnostic;
var ItemPriceDiagnosticInfo = function ItemPriceDiagnosticInfo(props) {
  return /*#__PURE__*/_react["default"].createElement(_ItemPriceDiagnosticInfo2["default"], _extends({
    i18n: (0, _i18n.getI18nInstance)()
  }, props));
};
exports.ItemPriceDiagnosticInfo = ItemPriceDiagnosticInfo;
var ItemPriceSummary = function ItemPriceSummary(props) {
  return /*#__PURE__*/_react["default"].createElement(_ItemPriceSummary2["default"], _extends({
    i18n: (0, _i18n.getI18nInstance)()
  }, props));
};
exports.ItemPriceSummary = ItemPriceSummary;
var ItemPriceAdjustment = function ItemPriceAdjustment(props) {
  return /*#__PURE__*/_react["default"].createElement(_ItemPriceAdjustment2["default"], _extends({
    i18n: (0, _i18n.getI18nInstance)()
  }, props));
};
exports.ItemPriceAdjustment = ItemPriceAdjustment;
var apis = {
  identities: {
    fetchAllFulfillers: _fulfillerIdentity.fetchAllFulfillers,
    fetchAllBillableEntities: _billableEntity.fetchAllBillableEntities,
    fetchAllMerchants: _merchantConfig.fetchAllMerchants,
    fetchAllAccounts: _accounts.fetchAllAccounts
  }
};
exports.apis = apis;